import * as React from "react";
import * as SeparatorPrimitive from "@radix-ui/react-separator";

import { cn } from "@/lib/utils"
import { cva } from "class-variance-authority"

const separatorVariants = cva("shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px", {
  variants: {
    variant: {
      "default": "bg-border",
      "theme": "bg-theme-border"
    }
  }
})

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root>) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
        className={cn(separatorVariants({ variant: "theme", className }))}
      {...props}
    />
  )
}

export { Separator };
